import React, { useContext } from "react";
import authContext from "../../contexts/auth/authContext";

const RenewIndex = (props) => {
    const { renewToken } = useContext(authContext);

    return (
        <div className="txt-center">
            <h1>Renew Token</h1>
            <button className="button" onClick={renewToken}>
                Renew
            </button>
        </div>
    );
};

export default RenewIndex;
